import { Component, Inject, isDevMode, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CustomWindow, WINDOW, AuthFacade } from '@woolworthsnz/styleguide';

@Component({
	selector: 'ss-trader-trader-bridge',
	templateUrl: './trader-bridge.component.html',
})
export class TraderBridgeComponent implements OnInit, OnDestroy {
	cookieName = 'cw-ssoc';
	kcSessionUrl: SafeResourceUrl;
	/**
	 * This component is designed to work independently from within an iframe. It should be on a route that is on the same domain as trader (akamai is used to route from the trader url to the account application for the bridge route). In that way it is able to initialise a trader session and post a message back to the parent window that a session has been started
	 */
	constructor(
		private domSanitizer: DomSanitizer,
		private authFacade: AuthFacade,
		@Inject(WINDOW) private window: CustomWindow
	) {
		//set the base api url from window env
		const windowEnv = window?.__env || {};
		this.kcSessionUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
			`${windowEnv.traderApiUrl
			}/api/v1/bff/initiate-oidc-signin?redirectUrl=${encodeURIComponent(
				windowEnv.traderApiUrl
			)}`
		);
	}

	ngOnInit(): void {

		window.document.addEventListener('sessionInitComplete', () => {
			//once the iframe has succesfully loaded we should refresh the context
			this.window.parent.postMessage('refreshContext', this.window?.__env.baseUrl);
		});
		this.authFacade.initialise();
		this.window.addEventListener('message', this.handleMessage.bind(this));
	}

	ngOnDestroy() {
		this.window.removeEventListener('message', this.handleMessage);
	}

	handleMessage(event: MessageEvent): void {
		if (event?.data === 'logoutContext' && ((event.origin.indexOf('countdown.co.nz') > -1 ||event.origin.indexOf('woolworths.co.nz')> -1)|| isDevMode())) {
			this.authFacade.logOut();
		}
	}
}
